import React from "react";
import PageHeader from "../components/PageHeader";
import { commonImg } from "../assets/assets";
import "../css/commontemplate.css";

export const SevaMandal = () => {
  return (
    <>
      <PageHeader
        title="श्रीदाजीमहाराज सेवामंडळ "
        path="/about-goshala"
        name=" goshala"
      />
      {/* <Initiatives /> */}
      <div className="comman-template-section">
        <div className="comman-template-container">
          {/* container  */}
          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={commonImg.com_sevamandal}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              <h3>श्रीदाजीमहाराज सेवामंडळ </h3>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp; श्रीक्षेत्र धनगर टाकळी येथे संस्थान व
                गुरुकुलाच्या माध्यमातून चालू असणाऱ्या सर्व सांस्कृतिक, 
                सामाजिक, शैक्षणिक इ. उपक्रमांना विस्तृत रूप देण्याच्या हेतूने श्रीदाजी
                महाराज सेवा मंडळाची स्थापना करण्यात आलेली आहे.
              </p>
            </div>
          </div>

          <div className="comman-template-sub-section"></div>
        </div>
      </div>
    </>
  );
};
